export const LIST_TYPES: string[] = ['numbered-list', 'bulleted-list'];
